if (!window.Subscription) {
  class Subscription extends HTMLElement {
    constructor() {
      super();
  
      this.selectors = {
        popup: '[js-sub-popup]',
        close: '[js-sub-close]'
      }

      // Create an observer to watch for changes in the DOM
      const observer = new MutationObserver((mutations, obs) => {
          const subscriptionRadio = document.getElementById("rc-radio2");
          if (subscriptionRadio) {
              console.log("Subscription radio button found");
              this.connectedCallback();
              obs.disconnect(); // Stop observing once we've found the element
          }
      });

      // Start observing the document body for changes
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
    }
  
    connectedCallback() {
      const purchaseOptions = document.querySelectorAll("input[name='purchaseOption']");
      purchaseOptions.forEach(option => {
          option.addEventListener("change", () => {
              console.log("Radio button state changed");
              this.toggleDescription();
          });
      });

      // Initial check when the elements are loaded
      this.toggleDescription();

      const link = this.querySelector('#sub-popupLink');
      const close = this.querySelector(this.selectors.close);
      link.addEventListener('click', this.showPopup);
      close.addEventListener('click', this.hidePopup);
      window.addEventListener('click', this.checkPopup);
    }

    toggleDescription = () => {
      const subscriptionRadio = document.getElementById("rc-radio2");
      const descriptionElement = this.querySelector(".subscription-description");

      if (subscriptionRadio && subscriptionRadio.checked) {
          console.log("Subscription option is checked");
          if (descriptionElement) {
              descriptionElement.classList.remove("d-none");
          }
      } else {
          console.log("Subscription option is not checked");
          if (descriptionElement) {
              descriptionElement.classList.add("d-none");
          }
      }
    }

    showPopup = (e) => {
      e.preventDefault();
      console.log('show')
      this.querySelector(this.selectors.popup).style.display = 'block';
    }

    hidePopup = (e) => {
      e.preventDefault();
      this.querySelector(this.selectors.popup).style.display = 'none';
    }

    checkPopup = (e) =>{
      if (e.target.classList.contains('sub-popup')){
        this.querySelector(this.selectors.popup).style.display = 'none';
      }
    }
  }
  
  window.Subscription = Subscription;

  if (!customElements.get('s-subscription')) {
    customElements.define('s-subscription', Subscription);
  }
}